import { render, staticRenderFns } from "./jf_login.vue?vue&type=template&id=1d4efd66&scoped=true&"
import script from "./jf_login.vue?vue&type=script&lang=js&"
export * from "./jf_login.vue?vue&type=script&lang=js&"
import style0 from "./jf_login.vue?vue&type=style&index=0&id=1d4efd66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4efd66",
  null
  
)

export default component.exports